import localForage from 'localforage';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAnalytics } from 'use-analytics';

import TodoList from '~/App/Modules/TodoList';
import usePurser from '~/react-hooks/use-purser';
import { GUIDE_REDIRECT_TO_QUICK_START } from '~/generated/AnalyticsTypes';
import { useGuideProgress } from '../Guide/NewQuickStarterGuide/api';
import { Service } from '~/types/models';
import { useMappedGuideProgress } from '~/react-hooks/use-mapped-guide-progress';
import { SessionCountsForQuickStartGuidePage } from '~/react-hooks/use-quick-start-guide-session-recorder';

export const homeUrl = '/home';

export default function Home() {
  const purser = usePurser();
  const history = useHistory();
  const analytics = useAnalytics();
  const sessionCount = purser.data?.count ?? 0;

  const { data: completedGuides = [], isLoading: isGuideProgressLoading } =
    useGuideProgress({ service: Service.VideoMessaging });

  const { isCompleted, loading: isMappedGuideProgressLoading } =
    useMappedGuideProgress({
      completedGuides,
      service: Service.VideoMessaging,
    });

  useEffect(() => {
    if (
      sessionCount === 0 ||
      isCompleted ||
      isGuideProgressLoading ||
      isMappedGuideProgressLoading
    )
      return;

    const redirectIfGuideViewed = async () => {
      if (SessionCountsForQuickStartGuidePage.includes(sessionCount)) {
        const isQuickStartGuideViewed = await localForage.getItem<boolean>(
          `${Service.VideoMessaging}-quick-start-guide-viewed-on-session-${sessionCount}`
        );
        if (
          typeof isQuickStartGuideViewed != 'undefined' &&
          !isQuickStartGuideViewed
        ) {
          document.title = 'Quick start guide';
          analytics.track(GUIDE_REDIRECT_TO_QUICK_START);
          history.replace(`/guide/${Service.VideoMessaging}`);
        }
      }
    };
    redirectIfGuideViewed();
  }, [
    sessionCount,
    isCompleted,
    isGuideProgressLoading,
    isMappedGuideProgressLoading,
  ]);

  return <TodoList />;
}
